module.exports = __webpack_public_path__ + "static/media/logotipo.18a36d0f.png";